import { AuditoriaPublicPage } from "pages/auditoria5s/AuditoriaPublicPage";
import Validacao from "pages/login/Validacao";
import React from "react";
import { Route } from "react-router";

export default function publicRoutes() {
    return (
        [
            <Route path="/public/auditoria" element={<AuditoriaPublicPage />} />,
            <Route path="/auth/action" element={<Validacao />} />
        ]

    )
}